import { z } from 'zod';
import { BoardModeSchema, BoardStatusSchema } from './assignments.js';
export const BoardDtoSchema = z.object({
    id: z.string().uuid(),
    studentId: z.string().uuid(),
    title: z.string(),
    previewUrl: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    // Assignment fields (present for all boards; defaults DRAFT/NEW/0)
    mode: BoardModeSchema,
    status: BoardStatusSchema,
    dueAt: z.string().nullable(),
    timeSpentSec: z.number().int().nonnegative(),
    tutorComment: z.string().nullable(),
    reviewedAt: z.string().nullable(),
    hintText: z.string().nullable(),
    hintVideoUrl: z.string().nullable(),
});
export const CreateBoardRequestSchema = z
    .object({
    title: z.string().trim().min(1).max(200).optional(),
})
    .transform((d) => ({ title: d.title ?? 'Без названия' }));
export const UpdateBoardRequestSchema = z.object({
    title: z.string().trim().min(1).max(200),
});
// tldraw document snapshot — shape определяется самой библиотекой, мы храним JSON as-is
export const BoardSnapshotSchema = z.object({
    document: z.unknown().optional(),
});
//# sourceMappingURL=boards.js.map